export interface EnvironmentConfig {
  isProduction: boolean
  faviconPrefix: string
  borderColor: string
  darkBorderColor: string
  environment: 'production' | 'staging' | 'development'
}

function getEnvironment(): 'production' | 'staging' | 'development' {
  // Use VITE_APP_ENV as the single source of truth
  const appEnv = import.meta.env.VITE_APP_ENV

  // Default to development if not set
  if (!appEnv) {
    return 'development'
  }

  // Validate and return the environment
  if (
    appEnv === 'production' ||
    appEnv === 'staging' ||
    appEnv === 'development'
  ) {
    return appEnv
  }

  // Fallback to development for any invalid values
  console.warn(
    `Invalid VITE_APP_ENV value: ${appEnv}. Defaulting to development.`,
  )
  return 'development'
}

function createEnvironmentConfig(): EnvironmentConfig {
  const environment = getEnvironment()
  const isProduction = environment === 'production'

  return {
    isProduction,
    environment,
    faviconPrefix: isProduction ? '' : 'staging-',
    borderColor: isProduction ? '#4E9680' : '#D4AF37', // Green for production, gold/yellow for staging/dev
    darkBorderColor: isProduction ? '#2D5A4B' : '#7A6520', // Muted versions for dark mode
  }
}

export const envConfig = createEnvironmentConfig()
